import React, { useState, Fragment, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import ReactPlayer from 'react-player'
import Navbar from "../../component/Other/Navbar";
import Contact from "../../component/Page/Contact";
import Footer from "../../component/Page/Footer";
import About from "../../component/Page/About";
import Testimonial from "../../component/Page/Testimonial";
import Memories from "../../component/Page/Memories";
import Blog from "../../component/Page/Blog";

const Index = (props) => {
  const [videoPlayer, setvideoPlayer] = useState(false)
  return (
    <Fragment>
      <div className="overflow-hidden">
        <div className="position-relative">
          <Navbar />

          <div className="wrapper__video-bg">
            <div className="bgwrap"></div>
            <img src="./../images/video.png" className={"ornament " + (videoPlayer ? "d-none" : "")} alt="" />
            <ReactPlayer
              className="vidbg"
              url="./../images/-068b-4a09-aebf-7aa228e696da (1).mp4"
              playing={true}
              muted={true}
              autoPlay={true}
              playsinline={true}
              loop={true}
              width="100%"
              height="100%"
              controls={false}
              onReady={() => {
                setvideoPlayer(true)
              }}
            />
          </div>
          <section className="position-relative z-2 section__home">
            <div className="container h-100 position-relative">
              <div className="wrapper__sosmed-head d-none d-lg-block">
                <div>
                  <a href="#!">
                    <img src="./../images/sos (1).png" alt="" />
                  </a>
                  <a href="#!">
                    <img src="./../images/sos (2).png" alt="" />
                  </a>
                  <a href="#!">
                    <img src="./../images/sos (3).png" alt="" />
                  </a>
                  <a href="#!">
                    <img src="./../images/sos (4).png" alt="" />
                  </a>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center position-relative z-2 h-100">
                <div className="text-center">
                  <p className="light ls__1 font__size--20 text__20-1024 color__white text-uppercase line__side mx-auto">Wedding Planner</p>
                  <h1 className="medium font__size--64 text__65-1024 text__65-sm text__65-xxs play color__white mb-0">Your Dream Wedding <br /> Made Perfect</h1>
                </div>
              </div>
            </div>

            <div className="wrapper__brand absolute d-flex flex-wrap flex-lg-nowrap align-items-center justify-content-center">
              <img src="./../images/bb (1).png" alt="" />
              <img src="./../images/bb (2).png" alt="" />
              <img src="./../images/bb (3).png" alt="" />
              <img src="./../images/bb (4).png" alt="" />
              <img src="./../images/bb (5).png" alt="" />
            </div>
          </section>
        </div>

        <About />


        <section>
          <div className="container">
            <div className="text-center mb-5">
              <div className="d-flex align-items-center justify-content-center normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                <img src="./../images/Vector 2.png" alt="" />
                <span className="mx-3">Services</span>
                <img src="./../images/Vector 1.png" alt="" />
              </div>
              <h2 className="medium font__size--56 text__50-1024 text__50-sm text__50-xs play">We are committed to providing <br className="d-none d-md-block" /> the best service</h2>
            </div>

            <div className="row">
              <div className="col-lg-4 mb-4 mb-lg-0">
                <div className="wrapper__sevice-card">
                  <img src="./../images/sv (3).png" alt="" />
                  <div className="bg"></div>
                  <div className="desc text-center">
                    <h5 className="semi-bold font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx play color__white">Design</h5>
                    <NavLink
                      to="/service/design" className="d-inline-block medium font__size--14 text__14-1024 color__white">Learn More</NavLink>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mb-4 mb-lg-0">
                <div className="wrapper__sevice-card">
                  <img src="./../images/sv (1).png" alt="" />
                  <div className="bg"></div>
                  <div className="desc text-center">
                    <h5 className="semi-bold font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx play color__white">Planning</h5>
                    <NavLink
                      to="/service/planning" className="d-inline-block medium font__size--14 text__14-1024 color__white">Learn More</NavLink>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="wrapper__sevice-card">
                  <img src="./../images/sv (2).png" alt="" />
                  <div className="bg"></div>
                  <div className="desc text-center">
                    <h5 className="semi-bold font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx play color__white">Photography</h5>
                    <NavLink
                      to="/service/photography" className="d-inline-block medium font__size--14 text__14-1024 color__white">Learn More</NavLink>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>


        <section>
          <div className="container">
            <div className="mb-5 text-center text-lg-left">
              <div className="d-flex align-items-center justify-content-center justify-content-lg-start normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                <img src="./../images/Vector 2.png" alt="" />
                <span className="mx-3">Benefit</span>
                <img src="./../images/Vector 1.png" alt="" />
              </div>

              <h2 className="medium font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx play">Perfect moments simply reveal <br className="d-none d-sm-block" /> themselves</h2>
            </div>

            <div className="row">
              <div className="col-sm-6 col-lg-3 mb-4 mb-lg-0">
                <div className="wrapper__card-moment">
                  <img src="./../images/lc (1).png" className="mb-3" alt="" />
                  <h4 className="medium font__size--32 text__32-1024  play">Saves Time and Energy</h4>
                  <p className="normal font__size--18 text__18-1024 color__gray-1">By using a wedding planner, you no longer have to worry about every detail of your wedding.</p>

                </div>
              </div>
              <div className="col-sm-6 col-lg-3 mb-4 mb-lg-0">
                <div className="wrapper__card-moment">
                  <img src="./../images/lc (3).png" className="mb-3" alt="" />
                  <h4 className="medium font__size--32 text__32-1024  play">Budget Management</h4>
                  <p className="normal font__size--18 text__18-1024 color__gray-1">A wedding planner can help you manage your wedding budget and provide advice on how to save money without sacrificing the quality or experience of your wedding.</p>

                </div>
              </div>
              <div className="col-sm-6 col-lg-3 mb-4 mb-lg-0">
                <div className="wrapper__card-moment">
                  <img src="./../images/lc (2).png" className="mb-3" alt="" />
                  <h4 className="medium font__size--32 text__32-1024  play">Efficient Coordination</h4>
                  <p className="normal font__size--18 text__18-1024 color__gray-1">A wedding planner can help coordinate all the vendors involved in your wedding, from catering to photographers.</p>

                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="wrapper__card-moment">
                  <img src="./../images/lc (4).png" className="mb-3" alt="" />
                  <h4 className="medium font__size--32 text__32-1024  play">Handling Unexpected Situations</h4>
                  <p className="normal font__size--18 text__18-1024 color__gray-1">By using a wedding planner, you can feel at ease and confident that every detail of your wedding is being taken care of.</p>

                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-6 my-md-auto mb-4">
                <div className="d-flex align-items-center normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                  <img src="./../images/Vector 2.png" alt="" />
                  <span className="mx-3">VENUES</span>
                  <img src="./../images/Vector 1.png" alt="" />
                </div>
                <h2 className="medium font__size--40 text__40-1024 text__40-md text__40-mm play">An unforgettable atmosphere awayfrom the crowd, for your crowd</h2>
                <p className="normal font__size--18 text__18-1024 mb-5">Exclusive access to Glasgow’s most iconic Neoclassical landmark, playing host to events of all varieties. The one thing our gala dinners, award ceremonies and celebrations have in common is that the building always breaks the ice. Dating back to 1844 and nestled within the grandeur of the Merchant City, the rich history of Citation contributes to its boastful vibrance and rusticity.</p>

                <NavLink
                      to="/book-now" className="medium font__size--14 text__14-1024 text__14-1024 btn btn__outlined--black color__black shadow text-capitalize rounded__50 h__white no__opacity pointer" >Book Now</NavLink>
              </div>
              <div className="col-md-6 text-right my-auto">
                <img src="./../images/asasas.png" alt="" />
              </div>
            </div>
          </div>
        </section>


        <section>
          <div className="container">
            <div className="mb-5">
              <div className="row">
                <div className="col-lg-8">
                  <div className="d-flex align-items-center normal font__size--24 text__24-1024 text-capitalize color__brown mb-3">
                    <img src="./../images/Vector 2.png" alt="" />
                    <span className="mx-3">Plan</span>
                    <img src="./../images/Vector 1.png" alt="" />
                  </div>
                  <h2 className="medium font__size--48 text__48-1024 text__48-md text__48-sm text__48-xx play">We’ve got a pricing plan that’s perfect for you</h2>
                </div>
                <div className="col-lg-4 d-none d-lg-block text-right mt-auto">
                  <NavLink
                      to="/plan" className="medium font__size--14 text__14-1024 btn btn__outlined--darkgreen color__darkgreen shadow h__white  no__opacity rounded__50">See All Pricing</NavLink>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 mb-4 my-lg-auto">
                <div className="wrapper__plan-price">
                  <h5 className="medium font__size--24 text__24-1024 play mb-3">Local event</h5>
                  <h2 className="medium font__size--32 text__32-1024  mb-3 play">$ 999.00 USD</h2>
                  <p className="normal font__size--16 mb-0">Wedding Planning Assistant Expands with Three New Localized Services
                  </p>
                  <hr className="hr__line-price my-3" />

                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">2</div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      Exclusive Venue Hire in the City Centre of Glasgow
                    </div>
                  </div>
                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">50</div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      Complimentary DJ for parties
                    </div>
                  </div>
                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.1468 24C12.964 23.9994 12.7832 23.9612 12.6158 23.8878C12.4483 23.8144 12.2978 23.7074 12.1734 23.5733L5.69345 16.68C5.45122 16.4219 5.32145 16.0781 5.33271 15.7242C5.34396 15.3704 5.4953 15.0356 5.75345 14.7933C6.01159 14.5511 6.35539 14.4213 6.70921 14.4326C7.06303 14.4438 7.39788 14.5952 7.64011 14.8533L13.1334 20.7067L24.3468 8.44C24.4606 8.2983 24.6021 8.18136 24.7628 8.09635C24.9234 8.01135 25.0997 7.96009 25.2809 7.94571C25.4621 7.93133 25.6443 7.95414 25.8163 8.01274C25.9883 8.07134 26.1466 8.16448 26.2813 8.28646C26.416 8.40844 26.5244 8.55668 26.5997 8.72206C26.6751 8.88744 26.7158 9.06648 26.7195 9.24819C26.7231 9.42989 26.6895 9.61042 26.6209 9.77868C26.5522 9.94695 26.4498 10.0994 26.3201 10.2267L14.1334 23.56C14.0103 23.6965 13.8603 23.806 13.6928 23.8817C13.5253 23.9575 13.3439 23.9977 13.1601 24H13.1468Z" fill="#757B67" />
                      </svg>

                    </div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      Personalised menus
                    </div>
                  </div>
                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.1468 24C12.964 23.9994 12.7832 23.9612 12.6158 23.8878C12.4483 23.8144 12.2978 23.7074 12.1734 23.5733L5.69345 16.68C5.45122 16.4219 5.32145 16.0781 5.33271 15.7242C5.34396 15.3704 5.4953 15.0356 5.75345 14.7933C6.01159 14.5511 6.35539 14.4213 6.70921 14.4326C7.06303 14.4438 7.39788 14.5952 7.64011 14.8533L13.1334 20.7067L24.3468 8.44C24.4606 8.2983 24.6021 8.18136 24.7628 8.09635C24.9234 8.01135 25.0997 7.96009 25.2809 7.94571C25.4621 7.93133 25.6443 7.95414 25.8163 8.01274C25.9883 8.07134 26.1466 8.16448 26.2813 8.28646C26.416 8.40844 26.5244 8.55668 26.5997 8.72206C26.6751 8.88744 26.7158 9.06648 26.7195 9.24819C26.7231 9.42989 26.6895 9.61042 26.6209 9.77868C26.5522 9.94695 26.4498 10.0994 26.3201 10.2267L14.1334 23.56C14.0103 23.6965 13.8603 23.806 13.6928 23.8817C13.5253 23.9575 13.3439 23.9977 13.1601 24H13.1468Z" fill="#757B67" />
                      </svg>

                    </div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      In house PA/microphones for speeches
                    </div>
                  </div>
                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.1468 24C12.964 23.9994 12.7832 23.9612 12.6158 23.8878C12.4483 23.8144 12.2978 23.7074 12.1734 23.5733L5.69345 16.68C5.45122 16.4219 5.32145 16.0781 5.33271 15.7242C5.34396 15.3704 5.4953 15.0356 5.75345 14.7933C6.01159 14.5511 6.35539 14.4213 6.70921 14.4326C7.06303 14.4438 7.39788 14.5952 7.64011 14.8533L13.1334 20.7067L24.3468 8.44C24.4606 8.2983 24.6021 8.18136 24.7628 8.09635C24.9234 8.01135 25.0997 7.96009 25.2809 7.94571C25.4621 7.93133 25.6443 7.95414 25.8163 8.01274C25.9883 8.07134 26.1466 8.16448 26.2813 8.28646C26.416 8.40844 26.5244 8.55668 26.5997 8.72206C26.6751 8.88744 26.7158 9.06648 26.7195 9.24819C26.7231 9.42989 26.6895 9.61042 26.6209 9.77868C26.5522 9.94695 26.4498 10.0994 26.3201 10.2267L14.1334 23.56C14.0103 23.6965 13.8603 23.806 13.6928 23.8817C13.5253 23.9575 13.3439 23.9977 13.1601 24H13.1468Z" fill="#757B67" />
                      </svg>

                    </div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      Dedicated Events Coordinator
                    </div>
                  </div>

                  <a href="#!" className="medium font__size--14 text__14-1024 btn btn__outlined--darkgreen color__darkgreen shadow h__white  no__opacity w-100 rounded-0 mt-4">Choose Plan</a>
                </div>
              </div>
              <div className="col-lg-4 mb-4 my-lg-auto">
                <div className="wrapper__plan-price active">
                  <h5 className="medium font__size--24 text__24-1024 play mb-3">International event</h5>
                  <h2 className="medium font__size--32 text__32-1024  mb-3 play">$ 9,999.00 USD</h2>
                  <p className="normal font__size--16 mb-0">Wedding Planning Assistant Expands with Three New Localized Services
                  </p>
                  <hr className="hr__line-price my-3" />

                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">12</div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      Exclusive Venue Hire in the City Centre of Glasgow
                    </div>
                  </div>
                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">180</div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      Complimentary DJ for parties
                    </div>
                  </div>
                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.1468 24C12.964 23.9994 12.7832 23.9612 12.6158 23.8878C12.4483 23.8144 12.2978 23.7074 12.1734 23.5733L5.69345 16.68C5.45122 16.4219 5.32145 16.0781 5.33271 15.7242C5.34396 15.3704 5.4953 15.0356 5.75345 14.7933C6.01159 14.5511 6.35539 14.4213 6.70921 14.4326C7.06303 14.4438 7.39788 14.5952 7.64011 14.8533L13.1334 20.7067L24.3468 8.44C24.4606 8.2983 24.6021 8.18136 24.7628 8.09635C24.9234 8.01135 25.0997 7.96009 25.2809 7.94571C25.4621 7.93133 25.6443 7.95414 25.8163 8.01274C25.9883 8.07134 26.1466 8.16448 26.2813 8.28646C26.416 8.40844 26.5244 8.55668 26.5997 8.72206C26.6751 8.88744 26.7158 9.06648 26.7195 9.24819C26.7231 9.42989 26.6895 9.61042 26.6209 9.77868C26.5522 9.94695 26.4498 10.0994 26.3201 10.2267L14.1334 23.56C14.0103 23.6965 13.8603 23.806 13.6928 23.8817C13.5253 23.9575 13.3439 23.9977 13.1601 24H13.1468Z" fill="#757B67" />
                      </svg>

                    </div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      Personalised menus
                    </div>
                  </div>
                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.1468 24C12.964 23.9994 12.7832 23.9612 12.6158 23.8878C12.4483 23.8144 12.2978 23.7074 12.1734 23.5733L5.69345 16.68C5.45122 16.4219 5.32145 16.0781 5.33271 15.7242C5.34396 15.3704 5.4953 15.0356 5.75345 14.7933C6.01159 14.5511 6.35539 14.4213 6.70921 14.4326C7.06303 14.4438 7.39788 14.5952 7.64011 14.8533L13.1334 20.7067L24.3468 8.44C24.4606 8.2983 24.6021 8.18136 24.7628 8.09635C24.9234 8.01135 25.0997 7.96009 25.2809 7.94571C25.4621 7.93133 25.6443 7.95414 25.8163 8.01274C25.9883 8.07134 26.1466 8.16448 26.2813 8.28646C26.416 8.40844 26.5244 8.55668 26.5997 8.72206C26.6751 8.88744 26.7158 9.06648 26.7195 9.24819C26.7231 9.42989 26.6895 9.61042 26.6209 9.77868C26.5522 9.94695 26.4498 10.0994 26.3201 10.2267L14.1334 23.56C14.0103 23.6965 13.8603 23.806 13.6928 23.8817C13.5253 23.9575 13.3439 23.9977 13.1601 24H13.1468Z" fill="#757B67" />
                      </svg>

                    </div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      In house PA/microphones for speeches
                    </div>
                  </div>
                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.1468 24C12.964 23.9994 12.7832 23.9612 12.6158 23.8878C12.4483 23.8144 12.2978 23.7074 12.1734 23.5733L5.69345 16.68C5.45122 16.4219 5.32145 16.0781 5.33271 15.7242C5.34396 15.3704 5.4953 15.0356 5.75345 14.7933C6.01159 14.5511 6.35539 14.4213 6.70921 14.4326C7.06303 14.4438 7.39788 14.5952 7.64011 14.8533L13.1334 20.7067L24.3468 8.44C24.4606 8.2983 24.6021 8.18136 24.7628 8.09635C24.9234 8.01135 25.0997 7.96009 25.2809 7.94571C25.4621 7.93133 25.6443 7.95414 25.8163 8.01274C25.9883 8.07134 26.1466 8.16448 26.2813 8.28646C26.416 8.40844 26.5244 8.55668 26.5997 8.72206C26.6751 8.88744 26.7158 9.06648 26.7195 9.24819C26.7231 9.42989 26.6895 9.61042 26.6209 9.77868C26.5522 9.94695 26.4498 10.0994 26.3201 10.2267L14.1334 23.56C14.0103 23.6965 13.8603 23.806 13.6928 23.8817C13.5253 23.9575 13.3439 23.9977 13.1601 24H13.1468Z" fill="#757B67" />
                      </svg>

                    </div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      Dedicated Events Coordinator
                    </div>
                  </div>

                  <a href="#!" className="medium font__size--14 text__14-1024 btn btn__outlined--darkgreen color__darkgreen shadow h__white  no__opacity w-100 rounded-0 mt-4">Choose Plan</a>
                </div>
              </div>
              <div className="col-lg-4 mb-4 my-lg-auto">
                <div className="wrapper__plan-price">
                  <h5 className="medium font__size--24 text__24-1024 play mb-3">International event</h5>
                  <h2 className="medium font__size--32 text__32-1024  mb-3 play">$ 9,999.00 USD</h2>
                  <p className="normal font__size--16 mb-0">Wedding Planning Assistant Expands with Three New Localized Services
                  </p>
                  <hr className="hr__line-price my-3" />

                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">12</div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      Exclusive Venue Hire in the City Centre of Glasgow
                    </div>
                  </div>
                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">180</div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      Complimentary DJ for parties
                    </div>
                  </div>
                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.1468 24C12.964 23.9994 12.7832 23.9612 12.6158 23.8878C12.4483 23.8144 12.2978 23.7074 12.1734 23.5733L5.69345 16.68C5.45122 16.4219 5.32145 16.0781 5.33271 15.7242C5.34396 15.3704 5.4953 15.0356 5.75345 14.7933C6.01159 14.5511 6.35539 14.4213 6.70921 14.4326C7.06303 14.4438 7.39788 14.5952 7.64011 14.8533L13.1334 20.7067L24.3468 8.44C24.4606 8.2983 24.6021 8.18136 24.7628 8.09635C24.9234 8.01135 25.0997 7.96009 25.2809 7.94571C25.4621 7.93133 25.6443 7.95414 25.8163 8.01274C25.9883 8.07134 26.1466 8.16448 26.2813 8.28646C26.416 8.40844 26.5244 8.55668 26.5997 8.72206C26.6751 8.88744 26.7158 9.06648 26.7195 9.24819C26.7231 9.42989 26.6895 9.61042 26.6209 9.77868C26.5522 9.94695 26.4498 10.0994 26.3201 10.2267L14.1334 23.56C14.0103 23.6965 13.8603 23.806 13.6928 23.8817C13.5253 23.9575 13.3439 23.9977 13.1601 24H13.1468Z" fill="#757B67" />
                      </svg>

                    </div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      Personalised menus
                    </div>
                  </div>
                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.1468 24C12.964 23.9994 12.7832 23.9612 12.6158 23.8878C12.4483 23.8144 12.2978 23.7074 12.1734 23.5733L5.69345 16.68C5.45122 16.4219 5.32145 16.0781 5.33271 15.7242C5.34396 15.3704 5.4953 15.0356 5.75345 14.7933C6.01159 14.5511 6.35539 14.4213 6.70921 14.4326C7.06303 14.4438 7.39788 14.5952 7.64011 14.8533L13.1334 20.7067L24.3468 8.44C24.4606 8.2983 24.6021 8.18136 24.7628 8.09635C24.9234 8.01135 25.0997 7.96009 25.2809 7.94571C25.4621 7.93133 25.6443 7.95414 25.8163 8.01274C25.9883 8.07134 26.1466 8.16448 26.2813 8.28646C26.416 8.40844 26.5244 8.55668 26.5997 8.72206C26.6751 8.88744 26.7158 9.06648 26.7195 9.24819C26.7231 9.42989 26.6895 9.61042 26.6209 9.77868C26.5522 9.94695 26.4498 10.0994 26.3201 10.2267L14.1334 23.56C14.0103 23.6965 13.8603 23.806 13.6928 23.8817C13.5253 23.9575 13.3439 23.9977 13.1601 24H13.1468Z" fill="#757B67" />
                      </svg>

                    </div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      In house PA/microphones for speeches
                    </div>
                  </div>
                  <div className="list d-flex align-content-start">
                    <div className="number flex-shrink-0 text-center d-flex align-items-start justify-content-center play normal font__size--24 text__24-1024">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.1468 24C12.964 23.9994 12.7832 23.9612 12.6158 23.8878C12.4483 23.8144 12.2978 23.7074 12.1734 23.5733L5.69345 16.68C5.45122 16.4219 5.32145 16.0781 5.33271 15.7242C5.34396 15.3704 5.4953 15.0356 5.75345 14.7933C6.01159 14.5511 6.35539 14.4213 6.70921 14.4326C7.06303 14.4438 7.39788 14.5952 7.64011 14.8533L13.1334 20.7067L24.3468 8.44C24.4606 8.2983 24.6021 8.18136 24.7628 8.09635C24.9234 8.01135 25.0997 7.96009 25.2809 7.94571C25.4621 7.93133 25.6443 7.95414 25.8163 8.01274C25.9883 8.07134 26.1466 8.16448 26.2813 8.28646C26.416 8.40844 26.5244 8.55668 26.5997 8.72206C26.6751 8.88744 26.7158 9.06648 26.7195 9.24819C26.7231 9.42989 26.6895 9.61042 26.6209 9.77868C26.5522 9.94695 26.4498 10.0994 26.3201 10.2267L14.1334 23.56C14.0103 23.6965 13.8603 23.806 13.6928 23.8817C13.5253 23.9575 13.3439 23.9977 13.1601 24H13.1468Z" fill="#757B67" />
                      </svg>

                    </div>
                    <div className="desc normal font__size--20 text__20-1024 ml-2">
                      Dedicated Events Coordinator
                    </div>
                  </div>

                  <a href="#!" className="medium font__size--14 text__14-1024 btn btn__outlined--darkgreen color__darkgreen shadow h__white  no__opacity w-100 rounded-0 mt-4">Choose Plan</a>
                </div>
              </div>
            </div>

            <div className="d-lg-none text-center">
              <NavLink
                      to="/plan" className="medium font__size--14 text__14-1024 btn btn__outlined--darkgreen color__darkgreen shadow h__white  no__opacity rounded__50">See All Pricing</NavLink>
            </div>
          </div>
        </section>


        <Memories />

        <Testimonial />

        <Blog load={true} />

        <Contact />

        <Footer />
      </div >
    </Fragment >
  );
};

export default Index;
